module.exports = __webpack_public_path__ + "img/f34f971cefd654b2b25c485b3f581d0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo1.png
// module id = 909
// module chunks = 5